import React, { useState } from 'react';
import { Text, ImageBackground, ImageSourcePropType, StyleSheet, TouchableOpacity, View } from 'react-native';
import { GenericTouchableProps } from 'react-native-gesture-handler/lib/typescript/components/touchables/GenericTouchable';
import { useDimensions } from 'react-native-web-hooks';
import useFontSize from '../../shell/hooks/useFontSize';
import { parseRequire } from '../../utils/parseImageUrl';
import { Checkbox } from '../checkbox/Checkbox';

interface SettingsButtonProps {
    image: ImageSourcePropType,
    checked: boolean | undefined;
    text: string,

}

export const SettingsButton: React.FC<SettingsButtonProps & GenericTouchableProps> = ({ image, checked, text, ...rest }) => {
    const { width, height } = useDimensions().window;
    const v = parseRequire(require("@lss/common/game/assets/images/Menu/SET_V.webp"));
    const [selected, setSelected] = useState(false);

    const styles = StyleSheet.create({

        radioButton: {
            height: height / 13,
            aspectRatio: 415 / 81

        },
        vWrapper: {
            height: height / 20,
            position: "absolute",
            top: 0,
            left: 0,
            right: "80%",
            bottom: 0,
            // top: "11%",
            // left: 0,
        },
        v: {
            width: "100%",
            height: "100%"

        },
        text: {

        }

    });

    return (
        <TouchableOpacity {...rest}>
            {/* <Text style={styles.text}>{text}</Text> */}
            <Checkbox label={text} checked={!!checked} onCheck={() => { }}></Checkbox>
        </TouchableOpacity>
    );
};